import { Table, TableContainer, Thead, Tr, Th, Tbody, Td, Box, SkeletonText } from "@chakra-ui/react"
import { format } from "date-fns";

import DeleteIcon from "@/assets/DeleteIcon";
import EditIcon from "@/assets/EditIcon";
import { formatCurrency } from "@/utils/currency";
import SentIcon from "@/assets/SentIcon";
import DraftIcon from "@/assets/DraftIcon";
import ApprovedIcon from "@/assets/ApprovedIcon";
import RejectIcon from "@/assets/RejectIcon";
import UnpaidIcon from "@/assets/UnpaidIcon";
import PaidIcon from "@/assets/PaidIcon";
import Pagination from "../Layouts/Pagination";
import ButtonConfirm from "@/assets/ButtonConfirm";
import ButtonConfirmDisabled from "@/assets/ButtonConfirmDisabled";
import ReceivedIcon from "@/assets/ReceivedIcon";
import { COLORS } from "@/common/constants";

const TableInvoiceInspector = ({ dataList, isLoading, handleEdit, handleDelete, currentPageSize, handleChangePageSize, handleChangePageNumber, handlePay, currentPageNumber, totalPageNumber, hasNextPage }: any) => {
	const NUM_COLUMNS = 11;
	return (
		<TableContainer bgColor="#fff" borderRadius="13">
			<Box overflowX="auto">
				<Table variant='simple'>
					<Thead>
						<Tr>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Order Number</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Invoice ID</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Inspection Date</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Invoice Date</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Vessel Name</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Amount</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Invoice Status</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Payment Status</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Payment Confirmation</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Note</Th>
							<Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Action</Th>
						</Tr>
					</Thead>
					<Tbody>
						{isLoading &&
							<Tr>
								<Td colSpan={NUM_COLUMNS}>
									<SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
								</Td>
							</Tr>
						}
						{(!isLoading && (!dataList || dataList.length === 0)) &&
							<Tr>
								<Td colSpan={NUM_COLUMNS} textAlign="center">Data not found</Td>
							</Tr>
						}
						{!isLoading && dataList?.map((item: any) => {
							return (
								<Tr key={item.id}>
									<Td>{item.sequenceID || '-'}</Td>
									<Td>{item.invoiceNumber}</Td>
									<Td>{item.inspectionDate ? format(item.inspectionDate, 'dd-MM-yyyy') : '-'}</Td>
									<Td>{item.invoiceDate ? format(item.invoiceDate, 'dd-MM-yyyy') : '-'}</Td>
									<Td>{item.shipName}</Td>
									<Td>{item.amount ? formatCurrency(item.amount, item.currency, item.currency == 'IDR' ? 'id-ID' : 'en-US') : '-'}</Td>
									<Td textAlign='center'>
										<div style={{ display: 'flex', justifyContent: 'center' }}>
											{item.invoiceStatus === 0 && <DraftIcon />}
											{item.invoiceStatus === 1 && <ApprovedIcon />}
											{item.invoiceStatus === 2 && <SentIcon />}
											{item.invoiceStatus === 3 && <RejectIcon />}
										</div>
									</Td>
									<Td textAlign='center'>
										<div style={{ display: 'flex', justifyContent: 'center' }}>
											{item.paymentStatus === 0 && <UnpaidIcon />}
											{item.paymentStatus === 1 && <PaidIcon />}
											{/* {item.paymentStatus === 2 && <ApprovedIcon />}
                                            {item.paymentStatus === 3 && <RejectIcon />} */}
											{item.paymentStatus === 4 && <ReceivedIcon />}
										</div>
									</Td>
									<Td>
										<div style={{ display: 'flex', justifyContent: 'center' }}>
											{item.paymentStatus === 1 &&
												<ButtonConfirm onClick={() => handlePay(item.id)} style={{ cursor: 'pointer' }} />
											}
											{item.paymentStatus !== 1 &&
												<ButtonConfirmDisabled />
											}
										</div>
									</Td>
									<Td>{item.note || '-'}</Td>
									<Td style={{ display: 'flex', cursor: 'pointer', gap: 8, paddingTop: '26px', paddingBottom: '26px', justifyContent: 'center' }}>
										{(item.invoiceStatus == 0 || item.invoiceStatus === 3) ? <>
											<EditIcon onClick={() => handleEdit(item.id)} />
											<DeleteIcon onClick={() => handleDelete(item.id)} />
										</> : '-'}
									</Td>
								</Tr>
							)
						})}
					</Tbody>
				</Table>
			</Box>
			<Pagination currentPageSize={currentPageSize} currentPageNumber={currentPageNumber} totalPageNumber={totalPageNumber} handleChangePageSize={handleChangePageSize} handleChangePageNumber={handleChangePageNumber} hasNextPage={hasNextPage} />
		</TableContainer>
	)
}

export default TableInvoiceInspector;